import { useReducer } from 'react'

const actionTypes = {
  assignListingRef: 'ASSIGN_LISTING_REF',
  loadListingState: 'LOAD_LISTING_STATE',
}

const listingsReducer = (state, action) => {
  const listingIndex = state.findIndex(
    listing => listing.id === action?.listing?.id
  )
  switch (action.type) {
    case actionTypes.assignListingRef:
      if (listingIndex > -1) {
        state[listingIndex] = { ...state[listingIndex], ref: action.ref }
      }
      return state
    case actionTypes.loadListingState:
      if (action.listings) return [...action.listings]
      return [...state]
    default:
      return state
  }
}

export const useListings = () => {
  const initialState = []

  const [statefulListings, listingsDispatch] = useReducer(
    listingsReducer,
    initialState
  )

  const { assignListingRef, loadListingState } = actionTypes
  return {
    statefulListings,
    listingsDispatch,
    assignListingRef,
    loadListingState,
  }
}
